import { render, staticRenderFns } from "./EmergencyStatistics.vue?vue&type=template&id=36000248&scoped=true&"
import script from "./EmergencyStatistics.vue?vue&type=script&lang=js&"
export * from "./EmergencyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyStatistics.vue?vue&type=style&index=0&id=36000248&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36000248",
  null
  
)

export default component.exports